export default function getCsrfToken() {
  return getMetaValue('csrf-token')
}

function getMetaValue(name) {
  const element = document.head.querySelector(`meta[name="${name}"]`)
  return element.getAttribute("content")
}

